export function getDemoEnvironment(hostname: string): string | undefined {
	const changeengMatch = /^www\.(\w+)\.changeeng\.org$/.exec(hostname);
	if (changeengMatch) return changeengMatch[1];

	// Shared preview gateway: corgi-<pr>.preview.changeeng.org (canonical) and
	// preview-corgi-<pr>.preview.changeeng.org (legacy alias) both resolve to the
	// preview-corgi-<pr> namespace identifier (== APP_SUB_ENV). The leading
	// "preview-" is dropped from the gateway hostname — the domain already says preview.
	const previewGatewayMatch = /^(?:preview-)?corgi-(\d+)\.preview\.changeeng\.org$/.exec(hostname);
	if (previewGatewayMatch) return `preview-corgi-${previewGatewayMatch[1]}`;

	const previewOjosMatch = /^(preview-corgi-\d+)\.ojos-alligator\.ts\.net$/.exec(hostname);
	if (previewOjosMatch) return previewOjosMatch[1];

	return undefined;
}

export function isPreviewDemoEnvironment(env: string): boolean {
	return !!env && env.startsWith('preview-');
}
